export enum Weekdays {
  SUNDAY = 0,
  MONDAY = 1
}
